import { useAppStore } from '@/store/store';
import { selectShipmentSummary } from '@/store/selectors';
import { useState } from 'react';

export function FormulaBreakdown() {
  const summary = useAppStore(selectShipmentSummary);
  const mode = useAppStore((s) => s.mode);
  const dimDivisor = useAppStore((s) => s.dimDivisor);
  const [expanded, setExpanded] = useState(false);

  if (summary.totalCBM === 0 && summary.grossWeightKg === 0) return null;

  return (
    <div style={{ marginTop: 'var(--space-2)' }}>
      <h3 style={{ margin: 0 }}>
        <button
          type="button"
          className="btn btn-sm"
          onClick={() => setExpanded(!expanded)}
          aria-expanded={expanded}
          aria-controls="formula-breakdown-content"
          style={{ width: '100%', textAlign: 'left' }}
        >
          {expanded ? '▼' : '▶'} Formula Breakdown
        </button>
      </h3>
      {expanded && (
        <div
          id="formula-breakdown-content"
          role="region"
          aria-label="Formula breakdown details"
          style={{
            marginTop: 'var(--space-2)',
            padding: 'var(--space-3)',
            background: 'var(--color-bg-secondary)',
            borderRadius: 'var(--radius-md)',
            fontSize: 'var(--font-size-sm)',
            fontFamily: 'var(--font-family-mono)',
          }}
        >
          <div style={{ marginBottom: 'var(--space-2)' }}>
            <strong>Total CBM</strong> = sum(L × W × H × qty) / 1,000,000<br />
            = {summary.totalCBM.toFixed(4)} m³
          </div>
          <div style={{ marginBottom: 'var(--space-2)' }}>
            <strong>Gross Weight</strong> = sum(weight × qty) in kg<br />
            = {summary.grossWeightKg.toFixed(2)} kg
          </div>
          <div style={{ marginBottom: 'var(--space-2)' }}>
            <strong>DIM Weight</strong> =<br />
            {mode === 'ocean-lcl'
              ? `  CBM × 1000 = ${summary.totalCBM.toFixed(4)} × 1000 = ${summary.dimWeightKg.toFixed(2)} kg`
              : `  (L × W × H × qty) / ${dimDivisor} = ${summary.dimWeightKg.toFixed(2)} kg`
            }
          </div>
          <div style={{ marginBottom: 'var(--space-2)' }}>
            <strong>Chargeable Weight</strong> = max(actual, DIM)<br />
            = max({summary.grossWeightKg.toFixed(2)}, {summary.dimWeightKg.toFixed(2)}) = <strong>{summary.chargeableWeightKg.toFixed(2)} kg</strong>
          </div>
          <div>
            <strong>Density</strong> = {summary.grossWeightKg.toFixed(2)} / {summary.totalCBM.toFixed(4)} = {summary.cargoDensityKgPerCBM.toFixed(2)} kg/m³
          </div>
          {summary.lineResults.map((line, i) => (
            <div key={line.packageId} style={{ marginTop: 'var(--space-2)', paddingTop: 'var(--space-2)', borderTop: '1px solid var(--color-border)' }}>
              <strong>Line {i + 1}</strong>: {line.cbm.toFixed(4)} CBM, {line.dimWeight.toFixed(2)} DIM kg, {line.actualWeight.toFixed(2)} actual kg → {line.chargeableWeight.toFixed(2)} kg ({line.weightBasis})
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
